// file for resuable functions within component class lifecycle hooks.  Ideally these would be true
// react hooks, but most of our components with logic in them are classes still.
import { deepEqual } from 'fast-equals';

import { logError, logToServer } from 'middleware/logger';
import { buildErrorQueryStringForMartyPixel, trackError } from 'helpers/ErrorUtils';

export function componentDidCatchFullPageError(
  setErrorActionCreator,
  error,
  info,
  { logError: logConsoleError, logToServer: logErrorToServer } = {
    logError,
    logToServer
  },
  directedId
) {
  const message = `[APP] An error has occurred while rendering the main page: ${error}`;
  logConsoleError(message);
  logConsoleError('More information', info);
  logErrorToServer(`${message} | directedId=${directedId || 'unknown'} | stack=${error?.stack || 'none'}`);
  error.detailedMessage = message;
  setErrorActionCreator(message, error, 500);
}

export function trackErrorIfNew(prevError, newError) {
  if (!deepEqual(prevError, newError)) {
    trackError(newError.statusCode, newError.type, newError.event);
  }
}

export function trackErrorPageToMartyPixel(error, reduxConnectedTrackErrorToMartyPixel, trackToErrorCgi = trackError, directedId) {
  if (error) {
    const { statusCode, type, event } = error;
    const stack = error.stack || event?.stack || event?.extraInformation;
    trackToErrorCgi(statusCode, type, event, directedId, stack);
    const msg = buildErrorQueryStringForMartyPixel(statusCode, type, event, directedId, stack);
    reduxConnectedTrackErrorToMartyPixel(msg);
  }
}
